import { module } from 'angular';
import component from './free-draw.component';
import './free-draw.scss';

export default module('app.free-draw', [])
	.component('freeDraw', component)
	.name;
